export default __webpack_public_path__ + "static/ReactGlobalSummit2020-4b9a9ff80f0058816cb33977b7ee45c6.png";